import 'indexeddbshim'

declare global {
    interface Window {
        shimIndexedDB: IDBFactory
        mozIndexedDB: IDBFactory
        webkitIndexedDB: IDBFactory
        msIndexedDB: IDBFactory
    }
    interface Window {
        webkitIDBTransaction: IDBTransaction
        msIDBTransaction: IDBTransaction
        _IDBTransaction: IDBTransaction
    }
    interface Window {
        webkitIDBKeyRange: IDBKeyRange
        msIDBKeyRange: IDBKeyRange
        _IDBKeyRange: IDBKeyRange
    }
}

// This works on all devices/browsers, and only uses IndexedDBShim as a final fallback
export const IDB_indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB

export const IDB_IDBTransaction =
    window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction || window._IDBTransaction

export const IDB_IDBKeyRange =
    window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange || window._IDBKeyRange

// Add back onto the window just in case
window.shimIndexedDB = IDB_indexedDB
window.IDBTransaction = IDB_IDBTransaction as any
window.IDBKeyRange = IDB_IDBKeyRange as any
